export const RESERVED_TOP_LEVEL_SEGMENTS: ReadonlyArray<string> = [
    "introducer",
    "crm",
    "listings",
    "probate",
    "nps",
    "api",
    "v1",
    "public",
    "404",
];

const INTRODUCER_PORTAL_SUBPATHS: ReadonlyArray<string> = [
    "admin",
    "login",
    "logout",
    "dashboard",
    "cases",
];

export const RESERVED_INTRODUCER_SLUGS: ReadonlySet<string> = new Set<string>([
    ...RESERVED_TOP_LEVEL_SEGMENTS,
    ...INTRODUCER_PORTAL_SUBPATHS,
]);

export const isReservedIntroducerSlug = (slug: string): boolean =>
    RESERVED_INTRODUCER_SLUGS.has(slug.toLowerCase());
